export default __webpack_public_path__ + "static/media/information-icon-gray.9a162ae3.svg";